import React from 'react';

import AppPageHeader from 'components/common/AppPageHeader';
import PageRow from 'components/common/PageRow';
import Questions from './components/Questions';
import SupportForm from './components/SupportForm';
import PageContainer from 'components/common/PageContainer';

function SupportPage() {
  return (
    <PageContainer>
      <AppPageHeader title="Support" />

      <PageRow>
        <Questions />
        <SupportForm />
      </PageRow>
    </PageContainer>
  );
}

export default SupportPage;
